import HttpClient from '@/services/http-client'

class AnomalyTypeService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/anomaly-types/' + id)
  }

  async list(opts = {}) {
    const { page = 1, perPage = 10, text = null } = opts
    return this.rest.get('/v1/anomaly-types', {
      params: {
        page,
        limit: perPage,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/anomaly-types', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/anomaly-types/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/anomaly-types/' + id)
  }
}

export default () => new AnomalyTypeService()
